<div [formGroup]="formGroup">
  <sc-string-field labelDictionaryKey="tmc-yard.entity.transport.masterdata.string1" formControlName="value"></sc-string-field>
</div>
